import { PropsWithChildren } from 'react';

import { GridFields } from 'components';
import { useTranslation } from 'libs/i18n';
import { Section } from 'modules/client/common/components';
import { PropsWithTestAttribute } from 'types/testAttribute';

import { FormContent, FormContentProps } from './FormContent';

interface Props
  extends FormContentProps,
    PropsWithChildren,
    PropsWithTestAttribute {}

export const StatusesSection = ({ children, datax, ...formProps }: Props) => {
  const { t } = useTranslation();

  return (
    <Section
      datax={datax}
      title={t('client.client.generalSection.classification.title')}
    >
      <GridFields>
        <FormContent {...formProps} />
        {children}
      </GridFields>
    </Section>
  );
};
